module.exports = __webpack_public_path__ + "img/hook_KITO_HJK_4.0ceaf283.png";